<template>
    <div>
        <div class="dialog-body-h">
            {{ tableTitle(matObject) }}
        </div>
        <el-table
                size="mini"
                :max-height="maxHeight"
                style="margin-bottom: 4px;"
                v-loading="loading"
                element-loading-text="Loading material"
                empty-text="Highlight a material below"
                :data="tableMat"
                stripe>
            <el-table-column
                    label="Parameter"
                    prop="parameter"
                    width="155"
            >
            </el-table-column>
            <el-table-column
                    label="Value"
                    prop="value"
                    width="85"
            >
            </el-table-column>
            <el-table-column
                    label="Units"
                    prop="units"
                    width="60"
            >
            </el-table-column>
        </el-table>
        <small id="footer-note">Minimum hardness and stress values displayed</small>
    </div>
</template>

<script>
  export default {
    name: "MatTableParams",
    props: {
      // DATA
      matObject: Object,
      matType: String,  // ISO, AGMA

      // FORMAT
      maxHeight: String,
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      tableMat() {
        switch (this.matType) {
          case 'AGMA':
            return this.matObject ? this.$handlers.gear.tableAgma2001D04(this.matObject) : [];
          case 'ISO':
            return this.matObject ? this.$handlers.gear.tableIso633652003(this.matObject) : [];
          default:
            return [];
        }
      },
    },
    methods: {
      tableTitle(obj) {
        switch (this.matType) {
          case 'AGMA':
            return obj ? obj.designation + ' | ' + obj.heatTreatment : 'Material';
          case 'ISO':
            return obj ? obj.type : 'Material';
        }
      }
    }
  }
</script>

<style scoped>
    #footer-note {
        color: var(--color-secondary);
        font-size: .8em;
    }
</style>
